import { Component, ViewChild, ElementRef } from '@angular/core';
import { IonicPage, NavController, NavParams, MenuController, ModalController } from 'ionic-angular';
import { Chart } from "chart.js";
import { Moment } from 'moment';



@IonicPage()
@Component({
  selector: 'page-teambuilding',
  templateUrl: 'teambuilding.html',
})




export class TeambuildingEmployerPage {

  // Var déclarations
  @ViewChild("pieCanvas") pieCanvas: ElementRef;
  private lineChart: Chart;
  public creatingMode: Boolean;
  budgetRange: any = { lower: 0, upper: 100 };
  employeeRange: number = 10;
  allEmployee: boolean = true;
  serviceEvent: boolean = this.allEmployee;
  selectedDate: {startDate: Moment, endDate: Moment};




  constructor(public navCtrl: NavController, public navParams: NavParams, menu: MenuController, public modalCtrl: ModalController) {

  }



  ionViewDidLoad() {

  }

  ngOnInit() {
    this.creatingMode = false;
    this.lineChart = new Chart(this.pieCanvas.nativeElement, {
      type: "horizontalBar",
      data: {
        labels: ["Comptabilité", "Direction", "Qualité", "Production", "Logistique"],
        datasets: [
          {
            label: "évènement(s)",
            fill: false,
            lineTension: 0.1,
            borderColor: "rgba(75,192,192,1)",
            borderCapStyle: "butt",
            borderDash: [],
            backgroundColor: ["#DBEAF1", "#AED3E5","#2787B7","#035D8F","#024669", "#024669", "#AED3E5"],
            borderDashOffset: 0.0,
            borderJoinStyle: "miter",
            pointBorderColor: "rgba(75,192,192,1)",
            pointBackgroundColor: "#fff",
            pointBorderWidth: 1,
            pointHoverRadius: 5,
            pointHoverBackgroundColor: "rgba(75,192,192,1)",
            pointHoverBorderColor: "rgba(220,220,220,1)",
            pointHoverBorderWidth: 2,
            pointRadius: 1,
            pointHitRadius: 10,
            data: [1, 4, 1, 4, 6, 0, 0],
            spanGaps: false
          }
        ]
      },
      options: {
        legend: {
          display: false,
        },
        tooltips: {
          displayColors: false,
          callbacks: {
            title: function(tooltipItems, data) {
              return;
            },
            label: function(tooltipItem, data) {
              var datasetLabel = '';
              var label = data.labels[tooltipItem.index];
              return;
            }
          }
        },
        tooltipTemplate: "<%= value %>",
        onAnimationComplete: function () {
            this.showTooltip(this.datasets[0].bars);
        },

        tooltipEvents: [],

        showAllTooltips: false,
        responsive: true,
        scales: {
        },
      }
    });
  }

}



// WEBPACK FOOTER //
// ./src/pages/employer/teambuilding/teambuilding.ts